if ($("footer#footer").length) {
    $('footer#footer').after($('.footer-bottom').removeClass('container').wrapInner('<div class="container"></div>'))

    $('.overall-wrapper').append($('.h-zbozi'));
    $("#signature a:first").prepend('<span>Běžíme na</span>');
    $("#signature a:eq(1)").text("Shoptet");
    $('#signature').append('<span>| Nakódoval <a href="hhttps://www.shopcode.cz/" target="_blank">Shopcode</a></span>');

    $(document).on("click", ".custom-footer > div .h4", function () {
        const parent = $(this).closest(".custom-footer > div");
        $(".custom-footer > div").not(parent).removeClass("openIt");
        parent.toggleClass("openIt");
    });


    if ($(".in-index").length) {
        $('footer#footer').before($('#footer .reviewsWrap').clone());
    }

    if ($(".in-index").length) {
        $('footer#footer').before($('.blogsWrapper'));
    }
    $('footer#footer').before($('.uspora'));


    $("footer#footer .superContact").append(
        $("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"),
    );


    $("footer#footer .superContact").append(
        $("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail")
    );
    $("footer#footer .superContact span.mail").append(`<span class="info">${emailInfo}</span>`)
    $("footer#footer .superContact span.tel").append(`<span class="info">${telefonInfo}</span>`)

    $("footer#footer  ul.socials").append(
        $("footer#footer .contact-box li span.facebook").closest("li"),
    );


}





if ($(".in-index").length) {
    $(".mainCategories .primaryCatWrapper").append($("#footer .primaryCategories").children().clone());
}